<template>
  <div class="home-box">
    <v-touch v-on:swipeup="swipeup" class="wrapper">
      <div class="nian">
        <img src="@/assets/image/main/2021.png" alt="" />
      </div>
      <div class="lanz">
        <img src="@/assets/image/main/lanz.png" alt="" />
      </div>
      <div class="goujian">
        <img src="@/assets/image/main/goujian.png" alt="" />
      </div>
      <div class="gye">
        <img src="@/assets/image/main/gongye.png" alt="" />
      </div>
      <div class="ile"><img src="@/assets/image/main/inle.png" alt="" /></div>
      <div class="titlse">兰州市工业和信息化局</div>
      <div class="icon">
        <img src="@/assets/image/main/icon.png" alt="" />
      </div>
      <div class="shan">
        <img src="@/assets/image/main/shan.png" alt="" />
      </div>
    </v-touch>
  </div>
</template>

<script>
export default {
  mounted() {
    this.TrafficStatistics()
  },
  data() {
    return {};
  },
  methods: {
    // 浏览量统计
    TrafficStatistics(){
      this.getAction('/sys/visit/updateCount',{
        ipAdd: returnCitySN["cip"]
      })
    },
    swipeup: function () {
      this.$router.push("/preface");
    },
  },
};
</script>

<style lang='scss'>
.home-box {
  .nian {
    img {
      width: 30%;
      height: auto;
      position: absolute;
      top: 12%;
      left: 36%;
      -webkit-animation: roll-in-left 0.7s ease-out both;
      animation: roll-in-left 0.7s ease-out both;
    }
  }
  .lanz {
    img {
      position: absolute;
      top: 28%;
      left: 21%;
      width: 59%;
      -webkit-animation: fade-in-top 0.7s cubic-bezier(0.39, 0.575, 0.565, 1)
        both;
      animation: fade-in-top 0.7s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    }
  }
  .goujian {
    img {
      width: 63%;
      position: absolute;
      top: 39%;
      left: 21%;
      -webkit-animation: fade-in-top 0.7s cubic-bezier(0.39, 0.575, 0.565, 1)
        both;
      animation: fade-in-top 0.7s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    }
  }
  .gye {
    img {
      width: 79%;
      position: absolute;
      top: 47%;
      left: 11%;
      -webkit-animation: fade-in-top 0.7s cubic-bezier(0.39, 0.575, 0.565, 1)
        both;
      animation: fade-in-top 0.7s cubic-bezier(0.39, 0.575, 0.565, 1) both;
    }
  }
  .ile {
    img {
      width: 70%;
      position: absolute;
      top: 54%;
      left: 16%;
      -webkit-animation: scale-in-hor-center 0.6s
        cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
      animation: scale-in-hor-center 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)
        both;
    }
  }
  .titlse {
    position: absolute;
    top: 61%;
    left: 31%;
    font-size: 14px;
    line-height: 62px;
    letter-spacing: 1px;
    color: #a3a2a2;
    -webkit-animation: scale-in-hor-center 0.6s
      cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    animation: scale-in-hor-center 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)
      both;
  }
  .icon {
    img {
      position: absolute;
      top: 66%;
      left: 47%;
      animation: slide-bck-bottom 1s linear infinite;
    }
  }
  .shan {
    img {
      width: 100%;
      position: fixed;
      bottom: 0%;
    }
  }
}
</style>
